import type { GeocodeFeature } from "@mapbox/mapbox-sdk/services/geocoding"

export type LocationParams = {
  lat: number
  lng: number
  postcode?: string
  city?: string
  state?: string
}

function findContext(context: GeocodeFeature[] | undefined, type: string) {
  return context?.find((c) => c.id.startsWith(type + "."))
}

export function extractLocationParams(feature: GeocodeFeature): LocationParams {
  const lat = feature.geometry.coordinates[1]
  const lng = feature.geometry.coordinates[0]
  const context = feature.context

  const placeType = feature.place_type[0]

  let postcode: string | undefined
  let city: string | undefined
  let state: string | undefined

  const regionContext = findContext(context, "region")
  if (regionContext?.short_code) {
    state = regionContext.short_code.replace(/^US-/, "")
  }

  if (placeType === "postcode") {
    postcode = feature.text
    city = findContext(context, "place")?.text
  } else if (placeType === "place") {
    city = feature.text
    postcode = findContext(context, "postcode")?.text
  } else {
    // Defensive: handles locality/neighborhood features. The Mapbox call currently
    // only requests types: ["place", "postcode"], so this branch shouldn't fire in
    // production — but it protects against future type additions or upstream changes.
    city = findContext(context, "place")?.text
    postcode = findContext(context, "postcode")?.text
  }

  return { lat, lng, postcode, city, state }
}
